import { useNoboEventsQuery } from "src/store/noboEvent";

export function useNoboEventCounts() {
  const { data: pendingApproval } = useNoboEventsQuery({
    tab: "pending_approval",
    limit: 1,
  });
  const { data: pendingDelivery } = useNoboEventsQuery({
    tab: "pending_delivery",
    limit: 1,
  });
  const { data: recentlyDelivered } = useNoboEventsQuery({
    tab: "recently_delivered",
    limit: 1,
  });

  return {
    pendingApproval: pendingApproval?.count ?? 0,
    pendingDelivery: pendingDelivery?.count ?? 0,
    recentlyDelivered: recentlyDelivered?.count ?? 0,
  };
}
